import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null
  },
  getters: {
    isLoggedIn: state => !!state.token,
    user: state => state.user
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    clearAuth(state) {
      state.user = null
      state.token = null
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    }
  },
  actions: {
    /**
     * 处理用户登录逻辑
     * @param {Object} context - Vuex上下文
     * @param {Object} payload - 登录参数
     * @param {string} payload.username - 用户名
     * @param {string} payload.password - 密码 
     * @param {boolean} payload.remember - 是否记住密码
     * @returns {Promise} 登录结果Promise
     */
    async login({ commit }, { username, password, remember }) {
      try {
        // 准备登录参数
        const params = {
          username,
          password,
        };
        
        // 调用登录API
        const response = await this._vm.$api.user.login(params);
        
        // 处理登录成功
        console.log(response);
        const { access_token, refresh_token } = response
        commit('setUser', username);
        commit('setToken', access_token);
        
        // 根据remember参数决定存储方式
        if (!remember) {
          // 不记住密码时使用sessionStorage
          sessionStorage.setItem('user', JSON.stringify(username));
          sessionStorage.setItem('token', access_token);
        }   
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    logout({ commit }) {
      commit('clearAuth')
      return Promise.resolve()
    }
  },
  modules: {
  }
})
